module.exports = __webpack_public_path__ + "img/in-transit.cba24b0f.svg";